import React from "react";
import PropTypes from "prop-types";
export function NewsLetterIcon({ width = 25, height = 25 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M237.315,160.322h-28.898v-17.064h24.348c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5h-24.348v-17.065h28.898
			c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5h-36.398c-4.142,0-7.5,3.358-7.5,7.5v64.129c0,4.142,3.358,7.5,7.5,7.5
			h36.398c4.142,0,7.5-3.358,7.5-7.5C244.815,163.68,241.457,160.322,237.315,160.322z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M172.156,96.194c-4.142,0-7.5,3.358-7.5,7.5v35.721l-22.375-39.423c-1.68-2.961-5.142-4.417-8.437-3.549
			c-3.292,0.869-5.585,3.847-5.585,7.251v64.129c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5v-35.721l22.375,39.423
			c1.355,2.388,3.872,3.799,6.522,3.798c0.635,0,1.278-0.081,1.915-0.249c3.292-0.869,5.585-3.847,5.585-7.251v-64.129
			C179.656,99.552,176.298,96.194,172.156,96.194z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M318.008,96.359c-4.054-0.861-8.035,1.723-8.897,5.774l-6.313,29.663l-6.313-29.663c-0.737-3.462-3.795-5.938-7.336-5.938
			c-3.54,0-6.599,2.476-7.335,5.938l-6.314,29.664l-6.313-29.664c-0.862-4.051-4.844-6.635-8.897-5.774
			c-4.051,0.862-6.636,4.846-5.774,8.897l13.649,64.129c0.736,3.462,3.794,5.938,7.335,5.938c3.541,0,6.599-2.476,7.335-5.938
			l6.314-29.664l6.313,29.664c0.737,3.462,3.795,5.938,7.336,5.938c3.541,0,6.599-2.476,7.335-5.938l13.649-64.129
			C324.644,101.204,322.059,97.221,318.008,96.359z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M360.629,128.717c-11.438-4.199-13.283-6.68-13.283-10.996c-0.001-3.081,4.574-6.528,10.698-6.528
			c6.124,0,10.699,3.447,10.699,6.528c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5c0-11.871-11.528-21.528-25.699-21.528
			c-14.171,0-25.699,9.658-25.699,21.528c0,16.592,14.469,21.904,23.115,25.077c11.437,4.198,13.283,6.68,13.283,10.996
			c0,3.082-4.575,6.528-10.699,6.528c-6.124,0-10.699-3.447-10.699-6.528c0-4.142-3.358-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5
			c0,11.871,11.528,21.528,25.699,21.528s25.699-9.658,25.699-21.528C383.743,137.201,369.274,131.89,360.629,128.717z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M454.365,172.619l-30.542-24.433V15.516C423.824,6.96,416.863,0,408.308,0H103.694c-8.556,0-15.516,6.96-15.516,15.516
			v132.67l-30.542,24.433c-6.062,4.85-9.539,12.083-9.539,19.847v287.986c0,17.396,14.152,31.548,31.548,31.548h352.71
			c17.396,0,31.548-14.152,31.548-31.548c0,0,0-286.34,0-287.986C463.904,184.703,460.427,177.469,454.365,172.619z M103.178,15.516
			c0-0.285,0.231-0.516,0.516-0.516h304.613c0.285,0,0.516,0.231,0.516,0.516v176.355c0,4.142,3.358,7.5,7.5,7.5
			c4.142,0,7.5-3.358,7.5-7.5v-24.476l21.171,16.937c2.484,1.988,3.909,4.952,3.909,8.134c0.001,2.782-1.082,5.398-3.049,7.366
			L380.085,265.6c-1.125-0.673-2.436-1.068-3.842-1.068h-104.21c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h94.119
			l-17.065,17.064h-77.055c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h62.055l-29.99,29.99l-8.784-8.784
			c-21.677-21.678-56.949-21.678-78.626,0l-8.784,8.784l-29.99-29.99h62.055c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5
			h-77.055l-17.065-17.064h94.119c4.142,0,7.5-3.358,7.5-7.5c0-4.142-3.358-7.5-7.5-7.5H135.759c-1.406,0-2.718,0.394-3.842,1.068
			l-28.739-28.739V15.516z M67.007,184.332l21.171-16.937v54.466l-22.03-22.03c-1.967-1.967-3.051-4.583-3.051-7.366
			C63.098,189.284,64.522,186.32,67.007,184.332z M432.356,497H79.646c-1.788,0-3.507-0.294-5.121-0.821l108.288-108.288
			c2.929-2.929,2.929-7.678,0-10.606c-2.929-2.929-7.678-2.929-10.606,0L63.918,485.573c-0.527-1.615-0.821-3.333-0.821-5.121
			V217.994l134.2,134.2l-2.713,2.713c-2.929,2.929-2.929,7.678,0,10.606c2.929,2.929,7.678,2.929,10.606,0l22.103-22.103
			c7.668-7.668,17.863-11.891,28.707-11.891s21.039,4.223,28.707,11.891l152.77,152.77C435.863,496.706,434.144,497,432.356,497z
			 M448.083,485.573l-133.38-133.38l134.2-134.2v262.459h0.001C448.904,482.24,448.61,483.959,448.083,485.573z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M376.243,56.113H135.759c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h240.483c4.142,0,7.5-3.358,7.5-7.5
			C383.742,59.471,380.385,56.113,376.243,56.113z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M376.243,200.403H135.759c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h240.483c4.142,0,7.5-3.358,7.5-7.5
			C383.742,203.761,380.385,200.403,376.243,200.403z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M239.969,232.468h-104.21c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h104.209c4.142,0,7.5-3.358,7.5-7.5
			C247.468,235.826,244.111,232.468,239.969,232.468z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M376.243,232.468h-104.21c-4.142,0-7.5,3.358-7.5,7.5c0,4.142,3.358,7.5,7.5,7.5h104.209c4.142,0,7.5-3.358,7.5-7.5
			C383.742,235.826,380.385,232.468,376.243,232.468z"
          />
        </g>
      </g>
    </svg>
  );
}

NewsLetterIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};
